import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { colorsPalette, SMALL_MARGIN } from '../../../../theme';

const useStyles = (finished) =>
  makeStyles((theme: Theme) =>
    createStyles({
      proportional: {
        position: 'relative',
        flex: '1',
        marginBottom: SMALL_MARGIN,
        [theme.breakpoints.up('md')]: {
          marginBottom: 0,
        },
      },
      imageLink: {
        position: 'relative',
        flex: '1',
        height: '100%',
        display: 'block',
      },
      imageWrapper: {
        height: '100%',
        cursor: 'pointer',
        '&::after': {
          content: '""',
          display: 'block',
          width: '100%',
          height: '100%',
          position: 'absolute',
          top: 0,
          left: 0,
          background: finished ? 'rgba(27, 25, 37, .66)' : 'transparent',
        },
      },
      titleWrapper: {
        color: colorsPalette.white,
      },
      title: {
        cursor: 'pointer',
      },
      infoRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      },
    }),
  );

export default useStyles;
